import { ReactNode } from "react";

const Alert = ({
  icon,
  text,
  style,
  color,
}: {
  icon: ReactNode;
  text: string;
  style?: "alert-outline" | "alert-dash" | "alert-soft";
  color?: "info" | "error" | "warning";
}) => {
  return (
    <div className={`alert ${style} ${"alert-" + color}`}>
      {icon}
      <span>{text}</span>
    </div>
  );
};
export default Alert;
